import { render, staticRenderFns } from "./VSelectIsapres.vue?vue&type=template&id=2838318a&"
import script from "./VSelectIsapres.vue?vue&type=script&lang=js&"
export * from "./VSelectIsapres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2838318a')) {
      api.createRecord('2838318a', component.options)
    } else {
      api.reload('2838318a', component.options)
    }
    module.hot.accept("./VSelectIsapres.vue?vue&type=template&id=2838318a&", function () {
      api.rerender('2838318a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/VSelectIsapres.vue"
export default component.exports